export const USER_PROFILE = {
  ACTIVITY: 10,
  COLLECTION: 20
}

export const MARKET_PLACE = {
  HOME: 20,
  ACTIVITY: 10
}

export const COLLECTION = {
  LIST: 16
}
